import { Settings } from "./types";

// Default settings
const defaultSettings: Settings = {
  skolidEnvironment: "prod",
  clientId: "com.ist.home.skolid.admin",
  localSessionTimeoutInSeconds: 60 * 15,
  demoFeatures: false
};

// Override settings per host
const hostSettings: { [key: string]: Partial<Settings> } = {
  "localhost:3000": {
    skolidEnvironment: "local",
    demoFeatures: true
  },
  
  "localhost:3001": {
    skolidEnvironment: "local",
    demoFeatures: true
  },

  "superadmin-dev.skolid.se": {
    skolidEnvironment: "dev",
    demoFeatures: true
  },

  "superadmin-dev.schulid.de": {
    skolidEnvironment: "devde",
    demoFeatures: true
  },

  "superadmin-demo.skolid.se": {
    skolidEnvironment: "demo",
    demoFeatures: true
  },

  "superadmin-demo.schulid.de": {
    skolidEnvironment: "demode",
    demoFeatures: true
  },

  "superadmin-staging.skolid.se": {
    skolidEnvironment: "staging"
  },

  "superadmin.skolid.se": {
    skolidEnvironment: "prod"
  },

  "superadmin.schulid.de": {
    skolidEnvironment: "prodde"
  },

  "superadmin-extacc.skolid.se": {
    skolidEnvironment: "extacc"
  },

  "skolid-extacc-admin.azurewebsites.net": {
    skolidEnvironment: "extacc"
  },
};

export const settings = {
  ...defaultSettings,
  ...(hostSettings[window.location && window.location.host] || {})
};
